import { useMemo, useState } from "react";
import { geoMercator, geoPath } from "d3-geo";
import { feature } from "topojson-client";
import topo from "@/assets/india_states.json";
import { formatINR } from "@/lib/api";

const FC = feature(topo, topo.objects.states);
const W = 520, H = 560;
const PROJ = geoMercator().fitSize([W, H], FC);
const PATH = geoPath(PROJ);

export default function IndiaSalesMap({ geo, selected, onSelect }) {
  const [tip, setTip] = useState(null);
  const byCode = useMemo(() => Object.fromEntries((geo || []).map((g) => [g.state_code, g])), [geo]);
  const max = useMemo(() => Math.max(...(geo || []).map((g) => g.sales), 1), [geo]);

  return (
    <div className="relative" data-testid="india-sales-map">
      <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-auto">
        {FC.features.map((f) => {
          const code = String(f.properties.st_code).padStart(2, "0");
          const g = byCode[code];
          const t = g ? Math.sqrt(g.sales / max) : 0;
          return (
            <path key={code} d={PATH(f)}
              fill={g ? `rgba(176,30,36,${(0.14 + 0.78 * t).toFixed(2)})` : "#EDF0F4"}
              stroke={selected === code ? "#0F172A" : "#fff"} strokeWidth={selected === code ? 1.6 : 0.7}
              className={g ? "cursor-pointer" : ""}
              data-testid={`map-state-${code}`}
              onClick={() => g && onSelect(selected === code ? "" : code)}
              onMouseMove={(e) => {
                const r = e.currentTarget.ownerSVGElement.getBoundingClientRect();
                setTip({ x: e.clientX - r.left, y: e.clientY - r.top, name: f.properties.st_nm, g });
              }}
              onMouseLeave={() => setTip(null)} />
          );
        })}
      </svg>
      {tip && (
        <div style={{ left: Math.min(tip.x + 12, 380), top: tip.y - 8 }}
          className="absolute pointer-events-none z-10 bg-slate-900 text-white text-[11px] rounded-md px-2.5 py-1.5 shadow-lg whitespace-nowrap">
          <span className="font-semibold">{tip.name}</span>
          {tip.g ? <> · {formatINR(tip.g.sales)} · {tip.g.share_pct}%</> : " · no sales"}
        </div>
      )}
    </div>
  );
}
